export const API = {
  projectPhases: '/projects/api/phases',
  projectSetList: '/sdg_project/project/projectssetlist',
};
